import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { ShareProjectModalComponent } from './share-project-modal.component';

@NgModule({
  declarations: [
    ShareProjectModalComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    TranslocoRootModule,
  ],
  exports: [
    ShareProjectModalComponent
  ],
})
export class ShareProjectModalModule { }
